export const SEE_POPUP_START = 'SEE_POPUP_START';
export const SEE_POPUP_SUCCESS = 'SEE_POPUP_SUCCESS';
export const SEE_POPUP_FAIL = 'SEE_POPUP_FAIL';
export const SEE_POPUP_RESET = 'SEE_POPUP_RESET';
